// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){

	// Baytek Slider Block
	$('.carousel-slider').each(function(){
		var slickIndividual = $(this);
		slickIndividual.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
		  	variableWidth: true,
			nextArrow: slickIndividual.next().find('.right'),
			prevArrow: slickIndividual.next().find('.left'),
			draggable: true,
			infinite: true,
		  	responsive: [
		  		{
					breakpoint: 720,
					// breakpoint: 1000,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	});
	// Show/Hide for the home page slider content
	var showChar = 100;
	var ellipsestext = "...";
	if ( document.documentElement.lang.toLowerCase() === "fr-fr" ) {
		var moretext = "Lire la suite";
		var lesstext = "Lire moins";
	} else{
		var moretext = "Read more";
		var lesstext = "Read less";		
	}

	$('.baytek_carousel-text').each(function () {
	    var content = $(this).html();
	    if (content.length > showChar) {
	        var show_content = content.substr(0, showChar);
	        var hide_content = content.substr(showChar, content.length - showChar);
	        var html = show_content + '<span class="moreelipses">' + ellipsestext + '</span><span class="remaining-content"><span>' + hide_content + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
	        $(this).html(html);
	    }
	});

	$(".morelink").click(function () {
	    if ($(this).hasClass("less")) {
	        $(this).removeClass("less");
	        $(this).parents('.baytek_carousel-text-container').find('.baytek_carousel-link').removeClass("less");
	        $(this).html(moretext);
	    } else {
	        $(this).addClass("less");
	        $(this).parents('.baytek_carousel-text-container').find('.baytek_carousel-link').addClass("less");
	        $(this).html(lesstext);
	    }
	    $(this).parent().prev().toggle();
	    $(this).prev().toggle();
	    return false;
	});
})(jQuery);